// Developed by Softvative.com
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const {
    FiHome, FiAlertTriangle, FiUsers, FiRefreshCw, FiBook,
    FiPackage, FiDatabase, FiClipboard, FiHardDrive
} = FiIcons;

const Sidebar = ({ collapsed }) => {
    const location = useLocation();

    const menuItems = [
        { path: '/', icon: FiHome, label: 'Dashboard', active: true },
        { path: '/incidents', icon: FiAlertTriangle, label: 'Incidents', active: true },
        { path: '/problems', icon: FiUsers, label: 'Problems', active: false },
        { path: '/changes', icon: FiRefreshCw, label: 'Changes', active: false },
        { path: '/knowledge', icon: FiBook, label: 'Knowledge', active: false },
        { path: '/releases', icon: FiPackage, label: 'Releases', active: false },
        { path: '/cmdb', icon: FiDatabase, label: 'CMDB', active: false },
        { path: '/requests', icon: FiClipboard, label: 'Service Requests', active: false },
        { path: '/assets', icon: FiHardDrive, label: 'Assets', active: false }
    ];

    return (
        <motion.div
            className={`bg-gradient-to-b from-indigo-900 via-indigo-800 to-indigo-900 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 text-white h-full flex flex-col transition-all duration-300 shadow-2xl ${collapsed ? 'w-16' : 'w-64'
                }`}
            initial={false}
            animate={{ width: collapsed ? 64 : 256 }}
        >
            {/* Logo */}
            <div className="p-4 border-b border-indigo-700 dark:border-gray-700">
                <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-lg flex items-center justify-center shadow-lg">
                        <SafeIcon icon={FiAlertTriangle} className="w-5 h-5" />
                    </div>
                    {!collapsed && (
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                        >
                            <h1 className="text-lg font-bold">ITSM Planner</h1>
                            <p className="text-xs text-indigo-300 dark:text-gray-400">ITIL Platform</p>
                        </motion.div>
                    )}
                </div>
            </div>

            {/* Navigation */}
            <nav className="flex-1 p-4 overflow-y-auto">
                <ul className="space-y-2">
                    {menuItems.map((item) => {
                        const isActive = location.pathname === item.path;
                        const isDisabled = !item.active;

                        return (
                            <li key={item.path} className="justify-items-start">
                                {item.active ? (
                                    <Link
                                        to={item.path}
                                        className={`flex items-center space-x-3 px-3 py-2.5 rounded-lg transition-all duration-200 group ${isActive
                                                ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg shadow-blue-600/30'
                                                : 'text-indigo-200 dark:text-gray-300 hover:bg-indigo-700/50 dark:hover:bg-gray-700 hover:text-white'
                                            }`}
                                    >
                                        <SafeIcon icon={item.icon} className="w-5 h-5 flex-shrink-0" />
                                        {!collapsed && (
                                            <motion.span
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1 }}
                                                exit={{ opacity: 0 }}
                                                className="font-medium text-sm"
                                            >
                                                {item.label}
                                            </motion.span>
                                        )}
                                    </Link>
                                ) : (
                                    <div className={`flex items-center space-x-3 px-3 py-2.5 rounded-lg transition-all duration-200 cursor-not-allowed opacity-50`}>
                                        <SafeIcon icon={item.icon} className="w-5 h-5 flex-shrink-0" />
                                        {!collapsed && (
                                            <motion.span
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1 }}
                                                exit={{ opacity: 0 }}
                                                className="font-medium text-sm"
                                            >
                                                {item.label}
                                            </motion.span>
                                        )}
                                        {!collapsed && (
                                            <span className="text-xs bg-indigo-700/50 dark:bg-gray-700 px-2 py-1 rounded text-indigo-300 dark:text-gray-400 ml-auto">
                                                Soon
                                            </span>
                                        )}
                                    </div>
                                )}
                            </li>
                        );
                    })}
                </ul>
            </nav>

            {/* Footer */}
            {!collapsed && (
                <div className="p-4 border-t border-indigo-700 dark:border-gray-700">
                    <div className="text-xs text-indigo-300 dark:text-gray-400 text-center">
                        <p>Developed by</p>
                        <a
                            href="https://softvative.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-400 hover:text-blue-300 transition-colors font-medium"
                        >
                            Softvative.com
                        </a>
                    </div>
                </div>
            )}
        </motion.div>
    );
};

export default Sidebar;